<div class="cpr-page">
  <div class="cpr-bg" aria-hidden="true">
    <div class="cpr-bg__mesh"></div>
    <div class="cpr-bg__orb cpr-bg__orb--1"></div>
    <div class="cpr-bg__orb cpr-bg__orb--2"></div>
  </div>

  <header class="cpr-topbar">
    <div class="cpr-topbar__brand">
      <img [src]="logoUrl" alt="Clinic logo" class="cpr-topbar__logo" />
      <div>
        <strong>Dr. Shailesh Sancheti</strong>
        <span>Homeopathy Clinic · Online Registration</span>
      </div>
    </div>
    <div class="cpr-topbar__badge">
      <i class="pi pi-shield"></i>
      Secure
    </div>
  </header>

  <div class="cpr-layout">
    <aside class="cpr-brand" aria-hidden="true">
      <div class="cpr-brand__content">
        <span class="cpr-brand__eyebrow">Patient self-registration</span>
        <h1>Register before your visit</h1>
        <p>
          Verify your mobile number, share a few details, and get a reference number to show at the reception desk.
        </p>
        <ul class="cpr-brand__list">
          <li><i class="pi pi-check-circle"></i> Takes about 2 minutes</li>
          <li><i class="pi pi-check-circle"></i> Staff reviews and activates your profile</li>
          <li><i class="pi pi-check-circle"></i> Your data stays private and encrypted</li>
        </ul>
        <img
          [src]="doctorFigureUrl"
          alt=""
          class="cpr-brand__figure"
          loading="lazy"
        />
      </div>
    </aside>

    <main class="cpr-card" @stepFade>
      <header
        class="cpr-mobile-hero"
        *ngIf="showDoctorHero"
        [ngClass]="'cpr-mobile-hero--' + doctorHeroTone"
      >
        <div class="cpr-mobile-hero__bg" aria-hidden="true">
          <span class="cpr-mobile-hero__glow cpr-mobile-hero__glow--1"></span>
          <span class="cpr-mobile-hero__glow cpr-mobile-hero__glow--2"></span>
          <span class="cpr-mobile-hero__dots"></span>
        </div>

        <div class="cpr-mobile-hero__inner">
          <div class="cpr-mobile-hero__copy">
            <span class="cpr-mobile-hero__pill">
              <i [class]="doctorHeroIcon"></i>
              {{ doctorHeroEyebrow }}
            </span>
            <h2 class="cpr-mobile-hero__title">{{ doctorHeroTitle }}</h2>
            <p class="cpr-mobile-hero__subtitle">{{ doctorHeroMessage }}</p>
            <ul class="cpr-mobile-hero__trust" *ngIf="showDoctorHeroTrust">
              <li><i class="pi pi-clock"></i> ~2 minutes</li>
              <li><i class="pi pi-shield"></i> Encrypted &amp; secure</li>
            </ul>
          </div>

          <div class="cpr-mobile-hero__visual">
            <span class="cpr-mobile-hero__ring" aria-hidden="true"></span>
            <img
              [src]="doctorFigureUrl"
              alt="Dr. Shailesh Sancheti"
              class="cpr-mobile-hero__figure"
              loading="eager"
            />
          </div>
        </div>

        <div class="cpr-mobile-hero__curve" aria-hidden="true"></div>
      </header>

      <nav class="cpr-progress" aria-label="Registration progress">
        <div
          class="cpr-progress__step"
          *ngFor="let item of progressSteps; let i = index"
          [class.is-active]="activeProgressIndex === i"
          [class.is-done]="activeProgressIndex > i"
        >
          <span class="cpr-progress__dot">
            <i class="pi" [ngClass]="activeProgressIndex > i ? 'pi-check' : item.icon"></i>
          </span>
          <span class="cpr-progress__label">{{ item.label }}</span>
        </div>
      </nav>

      <section *ngIf="step === 'lookup'" class="cpr-step" @stepFade>
        <header class="cpr-step__head">
          <span class="cpr-step__eyebrow">Step 1</span>
          <h2>Verify your identity</h2>
          <p>We will check if you already have a patient record with this mobile number.</p>
        </header>

        <div class="cpr-fields">
          <div class="cpr-row cpr-row--2">
            <div class="cpr-field">
              <label for="cpr-first">First name <em>*</em></label>
              <div class="cpr-input-wrap">
                <i class="pi pi-user"></i>
                <input
                  id="cpr-first"
                  pInputText
                  [(ngModel)]="lookup.first_name"
                  placeholder="First name"
                  autocomplete="given-name"
                />
              </div>
            </div>
            <div class="cpr-field">
              <label for="cpr-last">Last name <em>*</em></label>
              <div class="cpr-input-wrap">
                <i class="pi pi-user"></i>
                <input
                  id="cpr-last"
                  pInputText
                  [(ngModel)]="lookup.last_name"
                  placeholder="Last name"
                  autocomplete="family-name"
                />
              </div>
            </div>
          </div>

          <div class="cpr-field">
            <label for="cpr-mobile">Mobile number <em>*</em></label>
            <div class="cpr-input-wrap cpr-input-wrap--phone">
              <span class="cpr-phone-prefix">+91</span>
              <input
                id="cpr-mobile"
                pInputText
                [(ngModel)]="lookup.primary_contact"
                placeholder="10-digit number"
                maxlength="10"
                inputmode="tel"
                autocomplete="tel"
              />
            </div>
          </div>

          <input
            type="text"
            name="website"
            class="cpr-honeypot"
            tabindex="-1"
            autocomplete="off"
            [(ngModel)]="lookup.website"
          />
        </div>

        <button type="button" class="cpr-btn cpr-btn--primary" (click)="onLookup()" [disabled]="lookupLoading">
          <span>{{ lookupLoading ? 'Checking…' : 'Continue' }}</span>
          <i class="pi" [ngClass]="lookupLoading ? 'pi-spin pi-spinner' : 'pi-arrow-right'"></i>
        </button>

        <p class="cpr-note"><i class="pi pi-lock"></i> Encrypted connection · For clinic use only</p>
      </section>

      <section *ngIf="step === 'found' && foundMode === 'registered'" class="cpr-step" @stepFade>
        <header class="cpr-step__head cpr-step__head--center">
          <div class="cpr-icon-badge cpr-icon-badge--success"><i class="pi pi-check-circle"></i></div>
          <h2>You're already registered</h2>
          <p>{{ lookupResult?.message }}</p>
        </header>

        <div class="cpr-id-list">
          <article class="cpr-id-card" *ngFor="let p of lookupResult?.patients">
            <div>
              <span class="cpr-id-card__label">Patient ID</span>
              <strong class="cpr-id-card__id">{{ p.patient_number }}</strong>
              <span class="cpr-id-card__name">{{ p.display_name }}</span>
            </div>
            <button type="button" class="cpr-btn cpr-btn--soft cpr-btn--compact" (click)="copyPatientId(p.patient_number)">
              <i class="pi pi-copy"></i> Copy
            </button>
          </article>
        </div>

        <button type="button" class="cpr-btn cpr-btn--ghost" (click)="startOver()">
          <i class="pi pi-user-plus"></i> Register someone else
        </button>
      </section>

      <section *ngIf="step === 'found' && foundMode === 'pending'" class="cpr-step" @stepFade>
        <header class="cpr-step__head cpr-step__head--center">
          <div class="cpr-icon-badge cpr-icon-badge--pending"><i class="pi pi-clock"></i></div>
          <h2>Registration under review</h2>
          <p>{{ lookupResult?.message }}</p>
        </header>

        <div class="cpr-callout cpr-callout--info">
          Our team is reviewing your submission. You will be activated shortly — no need to register again.
        </div>

        <button type="button" class="cpr-btn cpr-btn--ghost" (click)="startOver()">
          <i class="pi pi-arrow-left"></i> Back to start
        </button>
      </section>

      <section *ngIf="step === 'register'" class="cpr-step" @stepFade>
        <header class="cpr-step__head">
          <span class="cpr-step__eyebrow">Step 2</span>
          <h2>Complete your profile</h2>
          <p *ngIf="lookupDisplayName">Registering as <strong>{{ lookupDisplayName }}</strong></p>
        </header>

        <div class="cpr-callout cpr-callout--shared" *ngIf="lookupResult?.shared_contact">
          <i class="pi pi-users"></i>
          <div>
            <strong>Shared mobile number</strong>
            <p>{{ lookupResult?.message }}</p>
            <div class="cpr-shared-tags" *ngIf="lookupResult?.others_on_number?.length">
              <span class="cpr-shared-tag" *ngFor="let o of lookupResult?.others_on_number">
                {{ o.display_name }} · {{ o.patient_number }}
              </span>
            </div>
          </div>
        </div>

        <div class="cpr-form-scroll">
          <div class="cpr-section">
            <h3 class="cpr-section__title"><i class="pi pi-id-card"></i> Personal</h3>
            <div class="cpr-row cpr-row--2">
              <div class="cpr-field">
                <label>First name <em>*</em></label>
                <input pInputText [(ngModel)]="form.first_name" placeholder="First name" autocomplete="given-name" />
              </div>
              <div class="cpr-field">
                <label>Last name <em>*</em></label>
                <input pInputText [(ngModel)]="form.last_name" placeholder="Last name" autocomplete="family-name" />
              </div>
            </div>
            <div class="cpr-field">
              <label>Middle name <span class="cpr-optional">optional</span></label>
              <input pInputText [(ngModel)]="form.middle_name" placeholder="Middle name" autocomplete="additional-name" />
            </div>
            <div class="cpr-row cpr-row--2">
              <div class="cpr-field">
                <label>Mobile</label>
                <div class="cpr-input-wrap cpr-input-wrap--phone cpr-input-wrap--locked">
                  <span class="cpr-phone-prefix">+91</span>
                  <span class="cpr-locked-text">{{ form.primary_contact }}</span>
                </div>
              </div>
              <div class="cpr-field cpr-field--age">
                <label>Age <em>*</em></label>
                <div class="age-input-with-hint">
                  <input
                    pInputText
                    type="number"
                    class="age-input-with-hint__input"
                    [ngModel]="form.age"
                    (ngModelChange)="onPatientAgeChange($event)"
                    (blur)="onPatientAgeBlur()"
                    min="0"
                    max="150"
                    step="any"
                    placeholder="e.g. 2.08"
                  />
                  <small class="age-input-with-hint__text cpr-field-hint">
                    <i class="pi pi-info-circle"></i>{{ patientAgeHint }}
                  </small>
                </div>
                <small class="cpr-field-error" *ngIf="patientAgeError">{{ patientAgeError }}</small>
              </div>
            </div>
            <div class="cpr-field">
              <label>Gender <em>*</em></label>
              <div class="cpr-pills">
                <button
                  type="button"
                  *ngFor="let g of genderOptions"
                  class="cpr-pill"
                  [class.is-on]="form.gender === g.value"
                  (click)="selectGender(g.value)"
                >
                  <i class="pi" [ngClass]="g.icon"></i>
                  {{ g.value }}
                </button>
              </div>
            </div>
          </div>

          <div class="cpr-section">
            <h3 class="cpr-section__title"><i class="pi pi-heart"></i> Medical <span class="cpr-optional">optional</span></h3>
            <div class="cpr-field">
              <label>Blood group</label>
              <div class="cpr-blood-grid">
                <button
                  type="button"
                  *ngFor="let bg of bloodGroups"
                  class="cpr-blood"
                  [class.is-on]="form.blood_group === bg"
                  (click)="selectBloodGroup(bg)"
                >
                  {{ bg }}
                </button>
              </div>
            </div>
          </div>

          <div class="cpr-section">
            <h3 class="cpr-section__title"><i class="pi pi-map-marker"></i> Contact <span class="cpr-optional">optional</span></h3>
            <div class="cpr-field">
              <label>Address</label>
              <textarea
                pInputTextarea
                [(ngModel)]="form.address"
                rows="2"
                placeholder="House no., street, area"
                class="cpr-textarea"
              ></textarea>
            </div>
            <div class="cpr-field">
              <label>City</label>
              <input pInputText [(ngModel)]="form.city" placeholder="City" autocomplete="address-level2" />
            </div>
          </div>
        </div>

        <input
          type="text"
          name="website"
          class="cpr-honeypot"
          tabindex="-1"
          autocomplete="off"
          [(ngModel)]="form.website"
        />

        <div class="cpr-actions">
          <button type="button" class="cpr-btn cpr-btn--ghost" (click)="goBackFromRegister()" [disabled]="submitLoading">
            Back
          </button>
          <button type="button" class="cpr-btn cpr-btn--primary" (click)="submitRegistration()" [disabled]="submitLoading || !isValidPatientAge(form.age)">
            <span>{{ submitLoading ? 'Submitting…' : 'Submit registration' }}</span>
            <i class="pi" [ngClass]="submitLoading ? 'pi-spin pi-spinner' : 'pi-send'"></i>
          </button>
        </div>
      </section>

      <section *ngIf="step === 'success'" class="cpr-step" @stepFade>
        <header class="cpr-step__head cpr-step__head--center">
          <div class="cpr-icon-badge cpr-icon-badge--success cpr-icon-badge--lg"><i class="pi pi-check"></i></div>
          <h2>Registration received</h2>
          <p>Thank you — our team will review and activate your profile shortly.</p>
        </header>

        <div class="cpr-receipt" *ngIf="referenceId">
          <span class="cpr-receipt__eyebrow">Your reference</span>
          <strong class="cpr-receipt__value">#{{ referenceId }}</strong>
          <p>Show this at the reception desk on your visit.</p>
          <button type="button" class="cpr-btn cpr-btn--soft cpr-btn--compact" (click)="copyReferenceId()">
            <i class="pi pi-copy"></i> Copy reference
          </button>
        </div>

        <ul class="cpr-next-steps">
          <li><i class="pi pi-building"></i> Visit the clinic with this reference number</li>
          <li><i class="pi pi-users"></i> Reception will confirm and link your patient ID</li>
          <li><i class="pi pi-calendar"></i> You can then book or attend your appointment</li>
        </ul>

        <button type="button" class="cpr-btn cpr-btn--primary" (click)="startOver()">
          <i class="pi pi-user-plus"></i> Register another person
        </button>
      </section>
    </main>
  </div>

  <footer class="cpr-footer">
    © {{ currentYear }} Dr. Shailesh Sancheti Homeopathy Clinic
  </footer>
</div>
